import * as EducationConstants from './constants';
import * as D from './deps';
import * as EducationSelectors from './selectors';

/**
 * Function to figure out what FTUX Audio
 *
 * @param {object} state - current state of the application
 * @returns {object} - url of audio, duration of audio, resumeTrackOnEnd
 */
export function getPremiumAccessFTUXEducationAudioData(state) {
  const count = EducationSelectors.getPremiumAccessEducationWelcomeMessageCount(state);
  const reachedPremiumAccessEducationMessageLimit =
    count >= D.TunerVarUtils.getPremiumAccessWelcomeMessageLimit(state);
  let url = D.TunerVarUtils.getPremiumAccessWelcomeMessageUrl(state);

  let sourceType = EducationConstants.SourceTypeConstants.FTUX_WELCOME_MESSAGE;
  if (reachedPremiumAccessEducationMessageLimit) {
    url = D.TunerVarUtils.getPremiumAccessStartToneUrl(state);
    sourceType = EducationConstants.SourceTypeConstants.FTUX_WELCOME_TONE;
  }
  return {
    url,
    sourceType,
    resumeTrackOnEnd: false,
  };
}

/**
 * Function to figure out what LTUX Audio
 *
 * @param {object} state - current state of the application
 * @param {boolean} shouldAlwaysPlayTone - should play tone regardless of message count
 * @returns {object} - url of audio, duration of audio, resumeTrackOnEnd
 */
export function getPremiumAccessLTUXEducationAudioData(state, shouldAlwaysPlayTone) {
  const reachedPremiumAccessEducationMessageLimit =
    EducationSelectors.reachedPremiumAccessEducationExitMessageLimit(state);
  let url = EducationConstants.PremiumAccessEducationConstants.PREMIUM_ACCESS_FTUX_EXIT_MESSAGE_URL;
  if (reachedPremiumAccessEducationMessageLimit || shouldAlwaysPlayTone) {
    url = D.TunerVarUtils.getPremiumAccessEndToneUrl(state);
  }
  return {
    url,
    resumeTrackOnEnd: false,
  };
}

/**
 * Function to figure out AntiAdBlocker URL
 *
 * @param {boolean} isHammerMode - Is Hammer mode enabled.
 * @returns {object} - url of audio, resumeTrackOnEnd
 */
export function getAntiAdBlockerEducationAudioUrl() {
  return {
    url: EducationConstants.AntiAdBlockerEducationConstants.HAMMER_MODE,
    resumeTrackOnEnd: false,
  };
}
